import { render, staticRenderFns } from "./ProductLabelList.vue?vue&type=template&id=5ebc48ea"
import script from "./ProductLabelList.vue?vue&type=script&lang=js"
export * from "./ProductLabelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports